import {
  TRemitterInfo,
  TIdentificationType,
} from './types';
import faker from '@faker-js/faker';
import loopMap from 'mn-utils/loopMap';

export const getNiumRemitterList = (limit: number = 5): TRemitterInfo[] => {
  return loopMap(limit, getNiumRemitterInfo) as TRemitterInfo[];
};

export const getNiumRemitterInfo = (): TRemitterInfo => {
  const identificationTypes = [
    'Registration Number',
    'Registration ID',
    'ACRA',
    'Travel Agent License number',
    'Company Registration No',
    'License No',
    'ARNU',
    'DRLC',
    'NIDN',
    'CCPT',
  ] as TIdentificationType[];

  return {
    nium_account_id: faker.datatype.uuid(),
    fiat_code: faker.finance.currencyCode(),
    name: faker.name.findName(),
    identification_type: (faker.helpers as any).arrayElement(identificationTypes),
    identification_number: faker.finance.iban(),
    country_code: faker.address.countryCode(),
    address: faker.address.streetAddress(true),
    source_of_income: faker.word.adjective(),
    contact_number: faker.phone.phoneNumberFormat(),
    city: faker.address.city(),
    postcode: faker.address.zipCodeByState('??'),
    state: faker.address.state(),
    source_of_funds: faker.word.adjective(),
    place_of_birth: faker.address.state(),
    nationality: faker.word.adjective(),
    occupation: faker.word.adjective(),
    ...(faker.datatype.boolean() ? {dob: faker.date.recent().toISOString()} : {}),
  } as TRemitterInfo;
};
